import React, { useEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import Animated, {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withDelay,
  withTiming,
} from 'react-native-reanimated';

import { theme } from '@garnish/constants';

export const OrderPlaybackTimer = (props: OrderPlaybackTimerProps) => {
  const { delay, duration, skipAnimation } = props;

  const animationProgress = useSharedValue(0);

  const animatedStyle = useAnimatedStyle(() => {
    const scaleX = animationProgress.value;
    return { transform: [{ scaleX }] };
  });

  useEffect(() => {
    animationProgress.value = skipAnimation
      ? 2
      : withDelay(delay, withTiming(2, { duration, easing: Easing.inOut(Easing.cubic) }));
  }, [animationProgress, delay, duration, skipAnimation]);

  return (
    <View style={styles.container}>
      <View style={styles.track}>
        <Animated.View style={[styles.animatedOverlay, animatedStyle]} />
      </View>
    </View>
  );
};

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: 4,
  },
  track: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: theme.colors.CUCUMBER,
    overflow: 'hidden',
  },
  animatedOverlay: {
    position: 'absolute',
    left: '-50%',
    width: '100%',
    height: '100%',
    backgroundColor: theme.colors.KALE,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type OrderPlaybackTimerProps = {
  delay: number;
  duration: number;
  skipAnimation: boolean;
};
